import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS, LAB_ABSTRACT } from "../data/products";
import { usePageMeta } from "../hooks/usePageMeta";

export const FAQ = () => {
    usePageMeta({
        title: "Research Peptide FAQ — Quantum Genesis Labs",
        description: "Common questions about Quantum Genesis Labs research peptides — products, storage, labeling, returns, and contact. Laboratory and research use only.",
        path: "/faq",
    });
    return (
        <div className="relative" data-testid="faq-page">
            <div className="absolute inset-x-0 top-0 h-[420px] overflow-hidden -z-10">
                <img src={LAB_ABSTRACT} alt="" className="w-full h-full object-cover opacity-20" />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#05050A]" />
            </div>

            <div className="max-w-4xl mx-auto px-5 lg:px-10 py-20">
                <header className="text-center mb-16">
                    <p className="text-xs tracking-[0.25em] uppercase text-indigo-400 mb-3">Support</p>
                    <h1 className="text-4xl md:text-5xl font-light tracking-tighter">
                        Frequently asked <span className="text-gradient">questions</span>
                    </h1>
                    <p className="mt-4 text-slate-400 leading-relaxed max-w-2xl mx-auto">
                        Clear answers on sourcing, storage, labeling, and ordering — written for researchers, not marketing.
                    </p>
                </header>

                <Accordion type="single" collapsible className="rounded-2xl border border-white/10 bg-[#0A0A12]/60 divide-y divide-white/5">
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            className="px-6 border-0"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="text-left text-base md:text-lg font-medium text-white hover:text-indigo-300 py-5 hover:no-underline">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-slate-400 leading-relaxed pb-5">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>

                <div className="mt-12 p-8 rounded-2xl border border-indigo-500/20 bg-indigo-500/5 text-center">
                    <h3 className="text-xl font-medium text-white mb-2">Still have questions?</h3>
                    <p className="text-sm text-slate-400 mb-5">Reach out directly for research inquiries, product information, or general support.</p>
                    <a
                        href="/contact"
                        data-testid="faq-contact-link"
                        className="inline-flex items-center gap-2 rounded-full bg-indigo-500 hover:bg-indigo-400 px-6 py-2.5 text-sm font-medium btn-glow"
                    >
                        Contact our team
                    </a>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
